
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/CriticaLifeCOVER",
      function () {
        return require("private-next-pages/CriticaLifeCOVER.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/CriticaLifeCOVER"])
      });
    }
  